module.exports = "<div *ngIf=\"true\" class=\"table-cont\">\n  <div class=\"ag-grid-component\" width=\"100%\" height=\"100%\" #myGrid id=\"myGrid\">\n  </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/ag-grid/ag-grid.component.html
// module id = ../../../../../src/app/common/ag-grid/ag-grid.component.html
// module chunks = main